import React, { useContext } from 'react';
import defaultTranslations from './translationsByLocale';
export const DEFAULT_LOCALE = 'en-gb';
const defaultTranslator = (key) => { var _a; return (_a = defaultTranslations[DEFAULT_LOCALE][key]) !== null && _a !== void 0 ? _a : key; };
const UIKitTranslationsContext = React.createContext(defaultTranslator);
export const useUIKitTranslator = () => useContext(UIKitTranslationsContext);
export const UIKitTranslatorProvider = ({ locale = DEFAULT_LOCALE, customTranslations = {}, children, }) => {
    const translations = Object.assign(Object.assign({}, defaultTranslations[locale]), customTranslations[locale]);
    return (React.createElement(UIKitTranslationsContext.Provider, { value: (key) => { var _a; return (_a = translations[key]) !== null && _a !== void 0 ? _a : key; } }, children));
};
